interface ErrorPanelProps {
  error: Error;
  onRetry: () => void;
}

export function LoadingPanel() {
  return (
    <div className="state-panel" role="status" aria-live="polite">
      <div className="spinner" aria-hidden="true" />
      <h2>Caricamento della Balanced Scorecard</h2>
      <p>Lettura e normalizzazione dei file Excel in corso.</p>
    </div>
  );
}

export function ErrorPanel({ error, onRetry }: ErrorPanelProps) {
  return (
    <div className="state-panel state-panel--error" role="alert">
      <h2>Impossibile caricare i dati</h2>
      <p>{error.message}</p>
      <div className="error-help">
        Controllare Identity Pool, policy IAM <code>s3:GetObject</code>, CORS del bucket e chiavi
        degli oggetti Excel.
      </div>
      <button className="button button--primary" type="button" onClick={onRetry}>
        Riprova
      </button>
    </div>
  );
}
